module.exports = __webpack_public_path__ + "static/img/VDappScenarios2-1.e9260d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/VDappScenarios2-1.png
// module id = joFv
// module chunks = 0